import { render, staticRenderFns } from "./MonitoringFormVolumeAlert.vue?vue&type=template&id=72eb598c&lang=pug"
import script from "./MonitoringFormVolumeAlert.vue?vue&type=script&lang=js"
export * from "./MonitoringFormVolumeAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports